import type { BadgeTooltipData } from "./display-badge";
import type { QuestBadgeConfig } from "./quest-card";

interface BadgeSet {
  locked: QuestBadgeConfig;
  unlocked: {
    imageUrl: string;
    alt: string;
    getTooltipData: (
      gameName: string,
      completionDate?: string,
    ) => BadgeTooltipData;
  };
}

const DISCORD_BADGE: BadgeSet = {
  locked: {
    imageUrl: "/images/quests/discord-badge-locked.webp",
    tooltipData: {
      title: "Discord Community Star",
      description: "Become an esteemed member and unlock extra rewards",
    },
    alt: "Discord Locked",
  },
  unlocked: {
    imageUrl: "/images/quests/discord-badge-unlocked.webp",
    alt: "Discord Community Star",
    getTooltipData: (gameName: string, completionDate?: string) => ({
      title: "Community Star",
      gameName,
      completionDate,
    }),
  },
};

const getBadgeSet = (questType: string): BadgeSet | undefined => {
  switch (questType) {
    case "join_discord_server":
    case "discord_engagement":
    case "discord_community_star":
      return DISCORD_BADGE;
    default:
      return undefined;
  }
};

// Get locked badge (for quest cards)
export const getBadgeConfig = (questType: string) =>
  getBadgeSet(questType)?.locked;

// Get unlocked badge (for page header/nav)
export const getUnlockedBadge = (questType: string) =>
  getBadgeSet(questType)?.unlocked;

// Check if quest type has a badge
export const hasBadge = (questType: string) => !!getBadgeSet(questType);
